import { CustomFieldDisplayItem } from '../api/CustomFieldDisplayItem';
import { WebsiteCustomFieldContactFormDisplayItem } from '../api/WebsiteCustomFieldContactFormDisplayItem';
import { WebsiteCustomFieldContactFormInputItem } from '../api/WebsiteCustomFieldContactFormInputItem';
import { WebsiteCustomFieldSignupFormDisplayItem } from '../api/WebsiteCustomFieldSignupFormDisplayItem';
import { WebsiteCustomFieldSignupFormInputItem } from '../api/WebsiteCustomFieldSignupFormInputItem';

declare module '../api/WebsiteCustomFieldSignupFormDisplayItem' {
    namespace WebsiteCustomFieldSignupFormDisplayItem {
        let ConvertToInputItem: typeof convertSignupToInputItem;
    }
}

declare module '../api/WebsiteCustomFieldContactFormDisplayItem' {
    namespace WebsiteCustomFieldContactFormDisplayItem {
        let ConvertToInputItem: typeof convertContactToInputItem;
    }
}

WebsiteCustomFieldSignupFormDisplayItem.ConvertToInputItem = convertSignupToInputItem;
WebsiteCustomFieldContactFormDisplayItem.ConvertToInputItem = convertContactToInputItem;

export function convertSignupToInputItem(displayItem: WebsiteCustomFieldSignupFormDisplayItem): WebsiteCustomFieldSignupFormInputItem {
    return new WebsiteCustomFieldSignupFormInputItem({
        Affinity: displayItem.Affinity,
        Name: displayItem.Name,
        OrderIndex: displayItem.OrderIndex,
        Field: CustomFieldDisplayItem.ConvertToInputItem(displayItem.Field!),
    });
}

export function convertContactToInputItem(displayItem: WebsiteCustomFieldContactFormDisplayItem): WebsiteCustomFieldContactFormInputItem {
    return new WebsiteCustomFieldContactFormInputItem({
        Name: displayItem.Name,
        OrderIndex: displayItem.OrderIndex,
        Field: CustomFieldDisplayItem.ConvertToInputItem(displayItem.Field!),
    });
}
